import { useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import axios from "axios";

const AuthCallback = ({ setUser }) => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  useEffect(() => {
    const token = searchParams.get("token");
    const username = searchParams.get("username");
    const discordId = searchParams.get("discordId");
    const type = searchParams.get("type");
    const error = searchParams.get("error");

    if (error) {
      localStorage.removeItem("zft_pending_register");
      navigate("/login?error=" + error);
      return;
    }

    if (token && username && type === "discord_user") {
      const user = { username, token, discordId, type };
      setUser(user);
      localStorage.setItem("zft_user", JSON.stringify({ user, loginTime: Date.now() }));

      // Check for a pending tournament registration (from guest "Join with Discord")
      const pendingRaw = localStorage.getItem("zft_pending_register");
      localStorage.removeItem("zft_pending_register");

      if (pendingRaw) {
        try {
          const { tournamentId, ts } = JSON.parse(pendingRaw);
          const age = Date.now() - ts;
          if (tournamentId && age < 60 * 60 * 1000) {
            // Auto-register, then go to tournaments list regardless of outcome
            axios
              .post(`/api/tournaments/${tournamentId}/register`, {}, {
                headers: { Authorization: `Bearer ${token}` }
              })
              .catch(() => {})
              .finally(() => navigate("/tournaments"));
            return;
          }
        } catch {
          // Malformed entry — fall through to default redirect
        }
      }

      navigate("/");
    } else {
      localStorage.removeItem("zft_pending_register");
      navigate("/login");
    }
  }, []); // runs once on mount

  return (
    <div style={{ display: "flex", alignItems: "center", justifyContent: "center", height: "60vh", flexDirection: "column", gap: "1rem" }}>
      <div className="spinner" style={{ width: 40, height: 40 }} />
      <p style={{ color: "var(--text-secondary)" }}>Logging you in via Discord...</p>
    </div>
  );
};

export default AuthCallback;
